export default __webpack_public_path__ + "static/media/espanol.1dce478a.png";